import React, { useState, useEffect } from "react";
import "../css/Dashboardfilter.css";

const DoctorFilterComponent = ({
  fromDate,
  toDate,
  setFromDate,
  setToDate,
  handleApplyFilter, // <-- NEW PROP
}) => {
  const [showFilters, setShowFilters] = useState(false);
  const [localFromDate, setLocalFromDate] = useState(fromDate || "");
  const [localToDate, setLocalToDate] = useState(toDate ||(""));
  const [error, setError] = useState(""); // <-- NEW STATE for validation message

  useEffect(() => {
    setLocalFromDate(fromDate || "");
    setLocalToDate(toDate || "");
  }, [fromDate, toDate]);

  const handleApply = () => {
    if (localFromDate && localToDate && localToDate < localFromDate) {
      setError("End date must be greater than or equal to start date");
      return;
    }

    setError("");
    setFromDate(localFromDate);
    setToDate(localToDate);
    handleApplyFilter(localFromDate, localToDate);
  };

  return (
    <div className="doctor-filter-container">
      <button
        className={`doctor-filter-toggle ${showFilters ? "active" : ""}`}
        onClick={() => setShowFilters((prev) => !prev)}
        aria-expanded={showFilters}
        aria-label="Toggle filters"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width={24}
          height={24}
          viewBox="0 0 24 24"
          className="doctor-filter-icon"
        >
          <path
            fill="currentColor"
            d="M6.532 4.75h6.936c.457 0 .854 0 1.165.03c.307.028.685.095.993.348c.397.326.621.814.624 1.322c.002.39-.172.726-.34.992c-.168.27-.411.59-.695.964l-2.596 3.422c-.252.332-.315.42-.359.51a1.2 1.2 0 0 0-.099.297c-.02.1-.023.212-.023.634v4.243c0 .208 0 .412-.014.578c-.015.164-.052.427-.224.663c-.21.287-.537.473-.9.495c-.302.019-.547-.103-.69-.183a7 7 0 0 1-.476-.31l-.989-.683l-.048-.033c-.191-.131-.403-.276-.562-.477a1.7 1.7 0 0 1-.303-.585c-.071-.244-.07-.5-.07-.738v-2.97c0-.422-.004-.534-.023-.634a1.2 1.2 0 0 0-.1-.297c-.043-.09-.106-.178-.358-.51L4.785 8.406c-.284-.374-.527-.694-.696-.964c-.167-.266-.34-.602-.339-.992a1.72 1.72 0 0 1 .624-1.322c.308-.253.686-.32.993-.349c.311-.029.707-.029 1.165-.029M5.308 6.305a.22.22 0 0 0-.057.134c.006.019.03.081.11.207c.128.205.33.472.64.881l2.575 3.394l.035.046c.201.264.361.475.478.715q.154.317.222.665c.051.261.05.527.05.864v2.968c0 .158.001.247.005.314l.006.062a.2.2 0 0 0 .036.073l.041.034c.05.04.12.088.248.176l.941.65V13.21c0-.337 0-.603.051-.864q.068-.347.222-.665c.117-.24.277-.45.478-.715l.035-.046l2.575-3.394c.31-.41.512-.676.64-.881c.08-.126.104-.188.11-.207a.22.22 0 0 0-.057-.134a1 1 0 0 0-.2-.032c-.232-.022-.556-.023-1.06-.023H6.568c-.504 0-.828 0-1.06.023a1 1 0 0 0-.2.032M15.75 10.5a.75.75 0 0 1 .75-.75h3a.75.75 0 0 1 0 1.5h-3a.75.75 0 0 1-.75-.75m-1.5 2.5a.75.75 0 0 1 .75-.75h4.5a.75.75 0 0 1 0 1.5H15a.75.75 0 0 1-.75-.75m-.5 2.5a.75.75 0 0 1 .75-.75h5a.75.75 0 0 1 0 1.5h-5a.75.75 0 0 1-.75-.75m0 2.5a.75.75 0 0 1 .75-.75H17a.75.75 0 0 1 0 1.5h-2.5a.75.75 0 0 1-.75-.75"
          ></path>
          <path
            fill="currentColor"
            d="M13.64 8H6.36l2.251 2.967c.201.264.361.475.478.715q.154.317.222.665c.051.261.05.527.05.864v2.968c0 .158.001.247.005.314l.006.062a.2.2 0 0 0 .036.073l.041.034c.05.04.12.088.248.176l.941.65V13.21c0-.337 0-.603.051-.864q.068-.347.222-.665c.117-.24.277-.45.478-.715z"
            opacity={0.5}
          ></path>
        </svg>
      </button>

      {showFilters && (
        <div className="doctor-date-dropdown">
          <label>
            From:
            <input
              type="date"
              value={localFromDate}
              onChange={(e) => setLocalFromDate(e.target.value)}
            />
          </label>
          <label>
            To:
            <input
              type="date"
              value={localToDate}
              min={localFromDate} // <-- Prevent selecting earlier dates
              onChange={(e) => setLocalToDate(e.target.value)}
            />
          </label>

          {error && <p className="doctor-date-error">{error}</p>} {/* <-- Error message */}

          <button className="doctor-apply-button" onClick={handleApply}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              viewBox="0 0 16 16"
              className="doctor-apply-icon"
            >
              <g
                fill="none"
                stroke="#BC2257"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
              >
                <path d="m14.25 8.75c-.5 2.5-2.3849 4.85363-5.03069 5.37991-2.64578.5263-5.33066-.7044-6.65903-3.0523-1.32837-2.34784-1.00043-5.28307.81336-7.27989 1.81379-1.99683 4.87636-2.54771 7.37636-1.54771" />
                <polyline points="5.75 7.75 8.25 10.25 14.25 3.75" />
              </g>
            </svg>{" "}
            Apply
          </button>
        </div>
      )}
    </div>
  );
};

export default DoctorFilterComponent;
